module.exports = __webpack_public_path__ + "img/phone-screen.fb76bc13.svg";